import styled from 'styled-components';
import theme from 'styled-theming';

export const tagBackgroundColor = theme('name', {
  light: 'rgba(0,0,0,0.08)',
  dark: 'rgba(255,255,255,0.08)',
});

export const backgroundColor = theme('name', {
  light: '#fff',
  dark: 'rgb(52, 52, 52)',
});

export const backgroundColorTR = theme('name', {
  light: 'rgba(242, 242, 242, 0.5)',
  dark: 'rgba(255, 255, 255, 0.1)',
});

export const LayoutBg = theme('name', {
  light: 'rgba(28, 28, 28, 0.04)',
  dark: 'rgb(28, 28, 28)',
});

const calculateTableHeight = (
  fixedHeight: boolean,
  maxHeight: number
): string => {
  if (fixedHeight) {
    return `height: ${maxHeight}px;`;
  }
  if (maxHeight > 0) {
    return `max-height: calc(100vh - ${maxHeight}px);`;
  }
  return 'max-height: none;';
};

export const TableWrapper = styled.div<{
  maxHeight: number;
  fixedHeight: boolean;
}>`
  position: relative;
  min-height: 100px;
  .table-container {
    text-align: center;
    overflow: auto;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    /* stylelint-disable selector-max-empty-lines */
    ${(props) => calculateTableHeight(props.fixedHeight, props.maxHeight)}

    tr {
      transition: background-color 0.2s ease;
    }
    /* stylelint-enable selector-max-empty-lines */

    tr:nth-child(even) {
      background-color: ${backgroundColorTR};
    }

    tr:hover {
      background-color: rgba(0, 120, 212, 0.05) !important;
    }

    th {
      padding: 16px;
      background-color: ${backgroundColorTR} !important;
      text-align: center;
      vertical-align: top;
      font-weight: 600;
      border-bottom: 2px solid rgba(0, 0, 0, 0.08);
    }

    td {
      text-align: center;
      padding: 12px 16px;
      transition: all 0.2s ease;
    }
  }

  .shell-table {
    width: 100%;
  }
  thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background: ${(props) => props.theme.background.surface};
  }

  .pagination-container {
    display: flex;
    justify-content: end;
    align-items: center;
    margin-top: 20px;
  }
  .select-page-size {
    width: 100px;
    margin-left: 10px;
  }
  .total-rows {
    margin-right: 10px;
  }

  .clear-filters {
    display: flex;
    justify-content: flex-end;
  }

  .no-data-cell {
    padding: 170px 20px;
    .title_wrapper {
      display: flex;
      justify-content: center;
    }
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 5px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  .filter {
    display: flex;
    flex-wrap: wrap;
    width: auto;
    border: 1px dashed rgba(145, 158, 171, 0.16);
    padding: 8px;
    gap: 8px;
    border-radius: 8px;
    overflow: hidden;
  }
  .display-label {
    font-weight: 600;
    font-size: 13px;
  }
  .display-value {
    display: flex;
    font-size: 12px;
    padding: 0 8px;
    border-radius: 8px;
    min-height: 24px;
    span {
      display: flex;
      gap: 3px;
      align-items: center;
      svg {
        display: flex;
        align-items: center;
        width: 15px;
        height: 16px;
        cursor: pointer;
        path {
          fill: #fff;
        }
      }
    }
  }

  .badge-button {
    min-width: max-content;
    padding: 0;
    margin-left: 5px;
  }
`;

export const ColumnTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  &.justify-content-start {
    justify-content: start;
  }

  &.justify-content-end {
    justify-content: end;
  }

  &.justify-content-center {
    justify-content: center;
  }

  .sorting-wrapper {
    display: flex;

    &.justify-content-start {
      justify-content: start;
    }
    &.justify-content-end {
      justify-content: end;
    }
    &.justify-content-center {
      justify-content: center;
    }

    .shell-table-column-sorter {
      margin: unset;
    }
    .shell-table-column-title {
      display: flex;
      align-items: flex-start;
    }
  }
  .pointer {
    cursor: pointer;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: end;
  padding: 5px 10px;
  .action-button {
    margin-left: 5px;
    max-height: 32px;
  }
  .filter-checkbox {
    .shell-checkbox {
      margin: 2.5px 0;
    }
  }
  .shell-select-selector {
    min-width: 230px;
    max-width: 330px;
  }
`;

export const TableLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.1);
  z-index: 1000;

  .loader-wrapper {
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
  }
`;
